import React from "react";
import { PrefillInput } from "@components/input";

const EmailField = () => (
  <PrefillInput
    title="Email Address"
    placeholder="Email Address"
    type="email"
    name={"emailAddress"}
  />
);

export default EmailField;
